import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()

const context = require.context("controllers", true, /_controller\.js$/)
const contextIngressosRepoShared = require.context(
  "../../../ingressos-repo/app/shared/javascripts/controllers",
  true,
  /redirecionar_parceiro_controller\.js$/
);

application.load(
  definitionsFromContext(context)
  .concat(definitionsFromContext(contextIngressosRepoShared))
);